import changeIsLoading from '../../actions/changeIsLoading';
import getTimeZone from '../../services/getTimeZone';
import initializeTimeZoneViewState from '../../actions/timeZone/initializeTimeZoneViewState';
import loadTimeZoneOption from '../../actions/timeZone/loadTimeZoneOption';
import TimeZoneViewState from '../../store/schema/TimeZoneViewState';
import updateTimeZoneViewState from '../../actions/timeZone/updateTimezoneViewState';
import { orchestrator } from 'satcheljs';

const loadTimeZoneOptionOrchestrator = orchestrator(
    loadTimeZoneOption,
    async (actionMessage: {}) => {
        // initialise the state
        initializeTimeZoneViewState();

        // start loading
        changeIsLoading(true);

        // get the timezone
        const supportedTimeZones = await getTimeZone();

        // update the view state
        updateTimeZoneViewState({ supportedTimeZones } as TimeZoneViewState);

        //change the loading state to false
        changeIsLoading(false);
    }
);

export default loadTimeZoneOptionOrchestrator;
